import { useState } from 'react';
import { useNavigate } from 'react-router';
import { jobTabPath } from '../../jobs/jobs.paths';
import { listJobTrips } from '../../jobs/features/trips/trips.api';
import { dispatchPaths } from '../dispatch.paths';
import { boardAssignTarget } from '../policies/board-assign-target.policy';

/** Assign opens the picker for the job's one waiting trip, or the job's Trips tab when there is none or several; it creates nothing (gitaumoses4/chukua#55). */
export function useAssignFromBoard() {
  const navigate = useNavigate();
  const [assigningJobId, setAssigningJobId] = useState<string | null>(null);
  const [failedJobId, setFailedJobId] = useState<string | null>(null);

  async function assign(jobId: string): Promise<void> {
    setAssigningJobId(jobId);
    setFailedJobId(null);
    try {
      const { trips } = await listJobTrips(jobId);
      const target = boardAssignTarget(trips);
      void navigate(target.kind === 'assign-trip' ? dispatchPaths.assignTrip(target.tripId) : jobTabPath(jobId, 'trips'));
    } catch {
      setFailedJobId(jobId);
    } finally {
      setAssigningJobId(null);
    }
  }

  return { assign, assigningJobId, failedJobId };
}
